import { Routes, Route, Link } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { Auth } from './components/Auth'
import TripTypes from './components/TripTypes'
import TripTypeDetail from './components/TripTypeDetail'
import Trips from './components/Trips'
import TripDetail from './components/TripDetail'

function AppContent() {
  const { user, loading, signOut } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Auth />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <header className="mb-8 flex justify-between items-center">
          <Link to="/" className="block">
            <h1 className="text-3xl font-bold text-gray-900 hover:text-blue-600 transition-colors">PackItinera</h1>
            <p className="text-gray-600 mt-2">Smart Packing List Management</p>
          </Link>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">{user.email}</span>
            <button
              onClick={signOut}
              className="text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
            >
              Sign Out
            </button>
          </div>
        </header>
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trip-types" element={<TripTypes />} />
          <Route path="/trip-types/:id" element={<TripTypeDetail />} />
          <Route path="/trips" element={<Trips />} />
          <Route path="/trips/:id" element={<TripDetail />} />
        </Routes>
      </div>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

function Home() {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-semibold mb-4">Welcome to PackItinera</h2>
      <p className="text-gray-600 mb-8">Manage your packing lists efficiently for every trip</p>
      <div className="space-y-4">
        <Link 
          to="/trips"
          className="block w-full max-w-sm mx-auto bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Create New Trip
        </Link>
        <Link 
          to="/trip-types"
          className="block w-full max-w-sm mx-auto bg-gray-600 text-white py-3 px-6 rounded-lg hover:bg-gray-700 transition-colors"
        >
          Manage Trip Types
        </Link>
      </div>
    </div>
  )
}

export default App
